import api from './api';

const data = (): Promise<any> => {
    return api('/content/contact-page');
};

export default {
    data,
};
